import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from 'env/environment';

@Injectable()
export class ExcludeHeaderRequestInterceptor implements HttpInterceptor {
  public constructor() {}

  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Likely this can be replaced by AuthenticationService.skipRequest by
    // examining the request url if starts with MCE base
    if (request.url.startsWith(environment.mceBase) || request.url.includes('cloudflare')) {
      const clonedRequest = request.clone({ headers: request.headers.delete('Authorization') });
      return next.handle(clonedRequest);
    }
    return next.handle(request);
  }
}
